import { OfferType, SubType } from '@shared/constants';
import { Step } from '@shared/factory';
import { Undefined } from '@shared/models';

import { ProductScopeDTO } from './product.dto';

export enum SelectErrorCode {
  ACCOUNT_ISSUE = 'ACCOUNT_ISSUE',
  MAX_SELECTION_REACHED = 'MAX_SELECTION_REACHED',
  OPTIN_REQUIRED = 'OPTIN_REQUIRED',
  AUTH_REQUIRED = 'AUTH_REQUIRED',
  OUT_OF_STOCK = 'OUT_OF_STOCK',
  ALREADY_SELECTED = 'ALREADY_SELECTED',
  CHALLENGE_NOT_SELECTABLE = 'CHALLENGE_NOT_SELECTABLE',
  CHALLENGES_NOT_FOUND = 'CHALLENGES_NOT_FOUND',
  CAMPAIGN_NOT_FOUND = 'CAMPAIGN_NOT_FOUND',
  CAMPAIGN_OVER = 'CAMPAIGN_OVER',
  MAX_ATTEMPTS_REACHED = 'MAX_ATTEMPTS_REACHED',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
}

export interface SelectErrorDTO {
  status_code: number;
  detail: string;
  error_code: SelectErrorCode;
}

export interface ChallengeBaseDTO {
  offerId: number;
  rank: number;
  type: OfferType;
  sub_type: SubType;
  selected_date: string;
  progress: number;
  reward: number;
  remaining_selections: Undefined<number>;
}

export interface StepChallengeDTO extends ChallengeBaseDTO {
  steps: Step[];
  drive_link: string;
  product_scope: ProductScopeDTO;
}

export interface FrequencyChallengeDTO extends ChallengeBaseDTO {
  target: number;
  reward_ratio: number;
  min_amount_by_transaction: number;
}

export interface ReferralChallengeDTO extends ChallengeBaseDTO {
  steps: Step[];
  code: string;
  nb_pending_sponsorships: number;
}

export interface SelectToWinChallengeDTO extends ChallengeBaseDTO {
  prize: number;
}

export type AnyChallengeDTO =
  | StepChallengeDTO
  | FrequencyChallengeDTO
  | ReferralChallengeDTO
  | SelectToWinChallengeDTO
  | ChallengeBaseDTO;
